<template>
    <section class="section-spacing">
    <v-container class="features-container">
        <HeadingWithPara :title="'WHY CHOOSE US'" :paragraph="'AN ENERGETIC TEAM DEDICATED TO QUALITY,'"
            :subText="'INNOVATION, AND RELIABLE SOLUTION FOR ALL YOUR PRINTING NEEDS.'" />

        <v-row class="justify-center cards-row">
            <v-col v-for="card in cards" :key="card.id" cols="12" :sm="6" :md="4" :lg="3" class="card-col">
                <div class="flip-card" data-aos="fade-up" :data-aos-delay="card.id * 100">
                    <div class="flip-card-inner">
                        <div class="flip-card-front">
                            <div class="card-icon-wrapper">
                                <img :src="card.image" :alt="card.title" class="card-icon" loading="lazy" />
                            </div>
                            <h3 class="card-title">{{ card.title }}</h3>
                        </div>
                        <div class="flip-card-back">
                            <p class="card-description">{{ getDescription(card.id) }}</p>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";
import HeadingWithPara from "@/components/HomeCompoent/HeadingWithPara.vue";

// Images
import cardImage1 from "@/assets/images/assurance.png";
import cardImage2 from "@/assets/images/price.png";
import cardImage3 from "@/assets/images/superservice.png";
import cardImage4 from "@/assets/images/team.png";
import cardImage5 from "@/assets/images/candle.png";
import cardImage6 from "@/assets/images/Service.png";
import cardImage7 from "@/assets/images/VarietyProduct.png";

// Card data
const cards = [
    { id: 1, image: cardImage1, title: "Quality Assurance" },
    { id: 2, image: cardImage2, title: "Competitive Pricing" },
    { id: 3, image: cardImage3, title: "Super Fast Service" },
    { id: 4, image: cardImage4, title: "Expert Team" },
    { id: 5, image: cardImage5, title: "5+ Years Experience" },
    { id: 6, image: cardImage6, title: "100K+ Services" },
    { id: 7, image: cardImage7, title: "Product Variety" },
];

// Get description for each card
const getDescription = (id) => {
    const descriptions = {
        1: "Our products undergo rigorous quality checks to ensure perfection in every print.",
        2: "We offer the best value with competitive pricing without compromising quality.",
        3: "Need it fast? We deliver exceptional quality with lightning-fast turnaround times.",
        4: "Our team of printing experts brings years of experience to every project.",
        5: "Over half a decade of delivering excellence in printing services.",
        6: "Trusted by thousands of clients for all their printing needs.",
        7: "From business cards to large banners, we've got all your printing needs covered."
    };
    return descriptions[id] || "Premium service you can trust.";
};

// Responsive screen width
const screenWidth = ref(window.innerWidth);
const updateScreenWidth = () => {
    screenWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener("resize", updateScreenWidth);
    AOS.init({
        once: true,
        duration: 800,
        easing: 'ease-out-cubic'
    });
});


onMounted(() => {
  const flipCards = document.querySelectorAll('.flip-card');
  
  flipCards.forEach(card => {
    card.addEventListener('click', function() {
      if (window.matchMedia("(hover: none)").matches) {
        this.classList.toggle('active');
      }
    });
  });
});

onUnmounted(() => {
    window.removeEventListener("resize", updateScreenWidth);
});
</script>

<style scoped>
.features-container {
  max-width: 1200px;
  /* padding: 80px 16px; */
}

.cards-row {
  margin-top: 40px;
}

.card-col {
  padding: 16px;
  perspective: 1000px;
}

.flip-card {
  width: 100%;
  height: 280px;
  max-width: 280px;
  margin: 0 auto;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
}

.flip-card-front {
  background: white;
}

.flip-card-back {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  transform: rotateY(180deg);
}

.card-icon-wrapper {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.card-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.card-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
}

.card-description {
  color: #555;
  font-size: 1rem;
  line-height: 1.5;
}

@media (max-width: 960px) {
  .flip-card {
    height: 260px;
  }
  
  .card-icon-wrapper {
    width: 70px;
    height: 70px;
    margin-bottom: 15px;
  }
  
  .card-title {
    font-size: 1.2rem;
  }
  
  .card-description {
    font-size: 0.95rem;
  }
}

@media (max-width: 600px) {
  .features-container {
    padding: 40px 16px;
  }
  
  .flip-card {
    height: 220px;
  }
  
  .card-icon-wrapper {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  
  .card-title {
    font-size: 1.1rem;
  }
  
  .card-description {
    font-size: 0.9rem;
  }
  
  .flip-card-front,
  .flip-card-back {
    padding: 20px;
  }
}

@media (hover: none) {
  .flip-card.active .flip-card-inner {
    transform: rotateY(180deg);
  }
}
</style>
